export const COMPARE_MAX_CHARS_EACH = 6_000;

export const COMPARE_NOT_READY =
  "Один из документов ещё не готов к сравнению. Дождитесь индекса или обновите его.";

export function compareSideTitle(title: string, version: number): string {
  const name = title.trim() || "Документ";
  return `${name} · версия ${version}`;
}

export function compareTask(
  titleA: string,
  titleB: string,
  focus: string,
): string {
  const trimmed = focus.trim();
  const base = `Сравни документы «${titleA}» (первый) и «${titleB}» (второй). Пиши, в каком файле какой факт.`;
  return trimmed ? `${base} Акцент: ${trimmed}` : base;
}
